import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserStatsThunk } from './userThunk';

const initialState = {
  web3Available: false,
  connected: false,
  isSidebarOpen: false,
  connectedAccount: null,
  chainId: null,
  contract: null,
  stats: {
    text: 0,
    nft: 0,
  },
};

export const getUserStats = createAsyncThunk('user/stats', getUserStatsThunk);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    connect: (state, { payload }) => {
      const { account, chainId, contract } = payload;
      state.web3Available = true;
      if (account) {
        state.connected = true;
        state.connectedAccount = account;
        state.chainId = chainId;
        state.contract = contract;
      } else {
        state.connected = false;
        state.connectedAccount = null;
        state.chainId = null;
        state.contract = null;
      }
    },
    disconnect: (state) => {
      state.connected = false;
      state.connectedAccount = null;
      state.chainId = null;
    },
  },
  extraReducers: {
    [getUserStats.pending]: (state) => {
      state.isLoading = true;
    },
    [getUserStats.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.stats = payload;
    },
    [getUserStats.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { toggleSidebar, connect, disconnect } = userSlice.actions;
export default userSlice.reducer;
